import { render, staticRenderFns } from "./pushList.vue?vue&type=template&id=ec7a8ca6"
import script from "./pushList.vue?vue&type=script&lang=js"
export * from "./pushList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports